var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#00AF35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7507 5.83301V14.9997C17.7507 16.008 16.9257 16.833 15.9173 16.833H5.83398V9.49967C5.83398 7.47384 7.47482 5.83301 9.50065 5.83301H17.7507Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1673 16.833V19.583C24.1673 21.1047 22.939 22.333 21.4173 22.333H20.5007C20.5007 21.3247 19.6757 20.4997 18.6673 20.4997C17.659 20.4997 16.834 21.3247 16.834 22.333H13.1673C13.1673 21.3247 12.3423 20.4997 11.334 20.4997C10.3257 20.4997 9.50065 21.3247 9.50065 22.333H8.58398C7.06232 22.333 5.83398 21.1047 5.83398 19.583V16.833H15.9173C16.9257 16.833 17.7507 16.008 17.7507 14.9997V8.58301H19.4373C20.0973 8.58301 20.7023 8.94052 21.0323 9.50885L22.5998 12.2497H21.4173C20.9132 12.2497 20.5007 12.6622 20.5007 13.1663V15.9163C20.5007 16.4205 20.9132 16.833 21.4173 16.833H24.1673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 24.1667C12.3459 24.1667 13.1667 23.3459 13.1667 22.3333C13.1667 21.3208 12.3459 20.5 11.3333 20.5C10.3208 20.5 9.5 21.3208 9.5 22.3333C9.5 23.3459 10.3208 24.1667 11.3333 24.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 24.1667C19.6798 24.1667 20.5007 23.3459 20.5007 22.3333C20.5007 21.3208 19.6798 20.5 18.6673 20.5C17.6548 20.5 16.834 21.3208 16.834 22.3333C16.834 23.3459 17.6548 24.1667 18.6673 24.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 15V16.8333H21.4167C20.9125 16.8333 20.5 16.4208 20.5 15.9167V13.1667C20.5 12.6625 20.9125 12.25 21.4167 12.25H22.5992L24.1667 15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/Bus.6d50030c5b90334eed35fb0f421aaa8e.svg";
export { ForwardRef as ReactComponent };